// Частые вопросы: один источник для витрин и страницы /faq (test-run-fixes: «Вопросы» в подвале
// вели на витрину миниатюры даже со страниц подарка). Текст не копируется.
export type FaqItem = { question: string; answer: string };

export const MATERIAL_ANSWER =
  "Из PLA-пластика на профессиональном FDM-принтере: сопло 0,2 мм, высота слоя 0,08 мм. Вблизи видны тонкие линии слоёв.";

export const FREE_ATTEMPT_ANSWER =
  "Эскиз — бесплатно. Новая бесплатная попытка появляется раз в 30 дней и сразу после каждой покупки.";

export const GIFT_FAQ: FaqItem[] = [
  {
    question: "Можно известного героя?",
    answer: "Опиши образ как хочешь, можно и любимого героя. Если генератор не сможет его нарисовать, попытка не сгорит.",
  },
  {
    question: "Можно с лицом друга?",
    answer: "Да, если он согласен. Фото другого человека можно загружать только с его разрешения.",
  },
  { question: "Сколько стоит попробовать?", answer: FREE_ATTEMPT_ANSWER },
  { question: "Из чего печатаете?", answer: MATERIAL_ANSWER },
];

export const MINI_FAQ: FaqItem[] = [
  { question: "Сколько стоит попробовать?", answer: FREE_ATTEMPT_ANSWER },
  {
    question: "Моего персонажа нет в списке",
    answer: "Под каталогом нажми «Опиши персонажа сам» — нарисуем по описанию. Мир и расу, если уже выбрал, подставим.",
  },
  {
    question: "Будет ли миниатюра похожа на меня?",
    answer: "До оплаты покажем лицо крупно и серую версию — такой миниатюра выйдет из принтера.",
  },
  { question: "Из чего печатаете?", answer: MATERIAL_ANSWER },
];

export const FAQ_PATH = "/faq";
export const GIFT_FAQ_PATH = `${FAQ_PATH}#gift`;
export const MINI_FAQ_PATH = `${FAQ_PATH}#mini`;
